import React from 'react'
import { CardTemplate } from '../../templates/CardTemplate'
import { ForgotPasswordForm } from '../../organisms/form/ForgotPasswordForm'
import { useForgotPasswordPage } from './hook';
import { useNavigation } from '../../../hooks/useNavigation';
import { PageRoute } from '../../../constants/routes';

export const ForgotPasswordPage = () => {
  const { handleForgotPassword } = useForgotPasswordPage();
  const { navigateToPage } = useNavigation();

  return (
    <CardTemplate title={"Forgot Password"}>
      <ForgotPasswordForm
        email={''}
        handleSubmit={handleForgotPassword}
        handleCancel={() => navigateToPage(PageRoute.LOGIN)}
      />
    </CardTemplate>
  )
}
